import "../../../../../Style/Dashboard/Insurance/Insurance.scss";
import { Col, DatePicker, Form, Input, Row, Tabs } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { BsFillBuildingsFill } from "react-icons/bs";
import { SiMicrosoftexcel } from "react-icons/si";
import { FaFilePdf, FaPlus } from "react-icons/fa";
import img from "../../../../../Assets/DOB.png";
import img1 from "../../../../../Assets/DEP.png";
import img2 from "../../../../../Assets/HPD.png";
import LL84 from "../LL84/LL84";
import LL87 from "../LL87/LL87";
import LL97 from "../LL97/LL97";
import LL126 from "../LL126/LL126";
import LL152 from "../LL152/LL152";
import BB from "../BB/BB";
import PP from "../PP/PP";
import CUSTOM from "../Custom/CUSTOM";
import { useLocation, useNavigate } from "react-router-dom";
import All from "../All";
import AllInspections from "../AllInspections";
import DEPTable from "../DEPIns/DEPTable";
import LL33Table from "../InspectionsTable/LL33Table/LL33Table";
import DEPNonComplianceTable from "../DEPNonCompliance/DEPNonComplianceTable";
import Listtable from "../List/Listtable";
import LL33table from "../InspectionsTable/LL33Table/LL33Table";

export default function LL33() {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("1");
  useEffect(() => {
    const path = location.pathname;
    if (path === "/DOB_AHV") {
      setActiveTab("2");
    } else {
      setActiveTab("1");
    }
  }, [location.pathname]);
  const [showSnapShort, setShowSnapShort] = useState(true);
  const tabDataArray = useMemo(
    () => [
      {
        key: "1",
        title: "ALL INSPECTIONS	",
      },
      {
        key: "2",
        icon: (
          <img
            src={img}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "BOLIER INSPECTIONS	",
      },
      {
        key: "3",
        icon: (
          <img
            src={img1}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "DEP INSPECTIONS ",
      },
      {
        key: "4",
        icon: (
          <img
            src={img}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "ELEVATOR	",
      },
      {
        key: "5",
        icon: (
          <img
            src={img}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "FACADE	",
      },
      {
        key: "6",
        icon: (
          <img
            src={img}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "LL33	",
      },
      {
        key: "7",
        icon: (
          <img
            src={img}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "LL84	",
      },
      {
        key: "8",
        icon: (
          <img
            src={img}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "LL87	",
      },
      {
        key: "9",
        icon: (
          <img
            src={img}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "LL97	",
      },
      {
        key: "10",
        icon: (
          <img
            src={img}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "LL126	",
      },
      {
        key: "11",
        icon: (
          <img
            src={img}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "LL152	",
      },
      {
        key: "12",
        icon: (
          <img
            src={img2}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "BEDBUG REPORT	",
      },
      {
        key: "13",
        icon: (
          <img
            src={img}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "PARAPET OBSERVATION	",
      },
      {
        key: "14",
        icon: (
          <img
            src={img}
            alt="Insurance Logo"
            className="icon-tabs-logo-insurance"
          />
        ),
        title: "CUSTOM INSPECTIONS	",
      },
      {
        key: "15",
        title: "DEP NON COMPLIANCE",
        icon: (
            <img
              src={img1}
              alt="Insurance Logo"
              className="icon-tabs-logo-insurance"
            />
          ),
      },
      {
        key: "16",
        title: "ELEVATOR LIST",
        icon: (
            <img
              src={img1}
              alt="Insurance Logo"
              className="icon-tabs-logo-insurance"
            />
          ),
      },
    ],
    []
  );
  const renderTabContent = () => {
    const selectedTab = tabDataArray.find((tab) => tab.key === activeTab);

    if (selectedTab) {
      return (
        <div className="main-logo-tabs-insurance">
          {selectedTab.icon}
          <h4 className="heading-tab-swo-insurance">{selectedTab.title}</h4>
        </div>
      );
    }

    return null;
  };
  useEffect(() => {
    const path = location.pathname;
    const tab = tabDataArray.find(
      (tab) => `/${tab.title.toLowerCase().replace(/\s/g, "_")}` === path
    );
    if (tab) {
      setActiveTab(tab.key);
    }
  }, [location.pathname, tabDataArray]);
  const handleTabChange = (key) => {
    setActiveTab(key);
    const selectedTab = tabDataArray.find((tab) => tab.key === key);
    if (selectedTab) {
      navigate(`/${selectedTab.title.toLowerCase().replace(/\s/g, "_")}`);
    }
    if (key === "1") {
      setShowSnapShort(true);
    } else if (key === "2") {
      setShowSnapShort(false);
    }
  };

  return (
    <>
      <div className="input-swo-main">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item>
              <Input
                placeholder="Building Filter"
                prefix={<BsFillBuildingsFill />}
              />
            </Form.Item>
          </Col>
          <div style={{ display: "flex" }}>
            <Col span={12}>
              <Form.Item>
                <DatePicker
                  style={{ width: "100%", height: "40px" }}
                  placeholder="Expires From "
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item>
                <DatePicker
                  style={{ width: "100%", height: "40px" }}
                  placeholder="To"
                />
              </Form.Item>
            </Col>
          </div>
        </Row>
      </div>

      <div style={{ padding: "20px" }}>
        <div className="main-dob-Active-insurance">
          {renderTabContent()}
          <div className="main-tabs">
            <div
              className="SiMicrosoftexcel-iconn-insurance"
              style={{ background: "#55C906" }}
            >
              <FaPlus style={{ color: "white", fontSize: "20px" }} />
            </div>

            <div
              className="SiMicrosoftexcel-iconn-insurance"
              style={{ background: "#008000" }}
            >
              <SiMicrosoftexcel style={{ color: "white", fontSize: "20px" }} />
            </div>
            <div
              className="SiMicrosoftexcel-iconn-insurance"
              style={{ background: "red" }}
            >
              <FaFilePdf style={{ color: "white", fontSize: "20px" }} />
            </div>
          </div>
        </div>
        <Tabs onChange={handleTabChange} type="card" activeKey={activeTab}>
          <Tabs.TabPane tab="ALL" key="1">
            {!showSnapShort && <AllInspections />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="DOB BOILER" key="2">
            {showSnapShort && <DEPTable />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="DEP BOILER" key="3">
            {!showSnapShort && <All />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="DEP Non-Compliance" key="15">
            {!showSnapShort && <DEPNonComplianceTable />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="ELEVATOR CARD" key="4">
            {!showSnapShort && <DEPTable />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="ELEVATOR LIST" key="16">
            {!showSnapShort && <Listtable />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="FACADE" key="5">
            {!showSnapShort && <DEPTable />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="LL33" key="6">
            {showSnapShort && <LL33table />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="LL84" key="7">
            {!showSnapShort && <LL84 />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="LL87" key="8">
            {!showSnapShort && <LL87 />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="LL97" key="9">
            {!showSnapShort && <LL97 />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="LL126" key="10">
            {!showSnapShort && <LL126 />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="LL152" key="11">
            {!showSnapShort && <LL152 />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="BB" key="12">
            {!showSnapShort && <BB />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="PP" key="13">
            {!showSnapShort && <PP />}
          </Tabs.TabPane>
          <Tabs.TabPane tab="CUSTOM" key="14">
            {!showSnapShort && <CUSTOM />}
          </Tabs.TabPane>
        </Tabs>
      </div>
    </>
  );
}
